export const buildPlayerSearchParams = ({
    query,
    resultLimit = 100,
    isProPlayerSearch = false,
    searchMembersOnly = false,
    showPickleballContent = false,
    showTennisContent = false,
    pin,
    distance,
} = {}) => {
    const params = new URLSearchParams();
    params.append('query', query);
    params.append('top', resultLimit);
    params.append('isDemoPlayer', false);
    params.append('showPickleballContent', false);
    params.append('showTennisContent', false);

    if (isProPlayerSearch) {
        params.append('filter', 'isPro:true');
    }

    if (searchMembersOnly) {
        params.append('exists', 'memberId');
    }

    if (showPickleballContent) {
        params.delete('showPickleballContent', false);
    }

    if (showTennisContent) {
        params.delete('showTennisContent', false);
    }

    if (pin) {
        params.append('pin', pin);
        if (distance) {
            params.append('distance', distance);
        }
    }

    return params;
};

// Parses the bulk "Player IDs" textarea (one ID per line, carriage-return
// separated) into a de-duplicated list of positive integers, dropping blank
// and non-numeric lines.
export const parsePlayerIds = (text) => {
    if (!text) {
        return [];
    }

    const ids = text
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0)
        .map((line) => Number(line))
        .filter((id) => Number.isInteger(id) && id > 0);

    return [...new Set(ids)];
};

export const getSessionPin = (sessionLocation) => {
    const lat = sessionLocation?.lat;
    const lng = sessionLocation?.lng;

    if (lat != null && lng != null) {
        return `${lat},${lng}`;
    }

    return undefined;
};

export const getDistanceLabel = (searchLocation) => {
    if (!getSessionPin(searchLocation)) {
        return 'Distance';
    }

    const place = searchLocation?.placeName || searchLocation?.formattedAddress;

    return place ? `Distance from ${place}` : 'Distance from location';
};

// The player search centers on the session's own location when it has one,
// otherwise walks up the ownership chain (conference, then league) — multi-round
// sessions have no location of their own. Returns the first location in the
// session -> conference -> league chain that has coordinates, or the session
// (pin-less) when none do, which searches everywhere.
export const getEffectiveSearchLocation = (sessionLocation, ...fallbackLocations) => {
    if (getSessionPin(sessionLocation)) {
        return sessionLocation;
    }

    const fallbackWithPin = fallbackLocations.find((location) => getSessionPin(location));
    if (fallbackWithPin) {
        return fallbackWithPin;
    }

    return sessionLocation;
};
